export const SNCR_LIMITE_MAXIMO_DIARIO = 50;
export const SNCR_LIMITE_MAXIMO_MENSAL = 3000;

export const SNCR_CATEGORIAS = Object.freeze({
  DIARIO: 'diario',
  MENSAL: 'mensal',
});
export const SNCR_LOTE_TEMPLATE = Object.freeze({
  dt_expiracao: null,
  in_total_nums_disponiveis: 0,
  in_total_nums_usados: 0,
  in_total_nums_lote: 0,
  st_num_disponivel: null
});

export const SNCR_TIPOS = Object.freeze([
  {
    sigla: 'NRA',
    nome: 'Notificação de Receita - Tipo: A',
    descricao: 'Substâncias de uso proscrito - Lista A1 e A2',
    categoria: SNCR_CATEGORIAS.DIARIO,
  },
  {
    sigla: 'NRB',
    nome: 'Notificação de Receita - Tipo: B',
    descricao: 'Psicotrópicos - Lista B1',
    categoria: SNCR_CATEGORIAS.DIARIO,
  },
  {
    sigla: 'NRB2',
    nome: 'Notificação de Receita - Tipo: B2',
    descricao: 'Psicotrópicos sujeitos a aprazamento - Lista B2',
    categoria: SNCR_CATEGORIAS.DIARIO,
  },
  {
    sigla: 'NRR',
    nome: 'Notificação de Receita - Tipo: Retinóide',
    descricao: 'Medicamentos à base de retinóides (ex.: isotretinoína)',
    categoria: SNCR_CATEGORIAS.DIARIO,
  },
  {
    sigla: 'NRT',
    nome: 'Notificação de Receita - Tipo: Talidomida',
    descricao: 'Prescrição e controle de talidomida',
    categoria: SNCR_CATEGORIAS.DIARIO,
  },
  {
    sigla: 'RCE',
    nome: 'Receita de Controle Especial',
    descricao: 'Medicamentos sujeitos a controle especial - Lista C',
    categoria: SNCR_CATEGORIAS.MENSAL,
  },
  {
    sigla: 'RET',
    nome: 'Receita Especial Talidomida',
    descricao: 'Controle especial de talidomida - Portaria SVS/MS nº 344',
    categoria: SNCR_CATEGORIAS.MENSAL,
  },
]);

export const SIGLAS_VALIDAS = new Set(SNCR_TIPOS.map(tipo => tipo.sigla));
